import { ActivityLogType } from "../../../../../../../../utils/constants";
import getScanLogContent from "./scanLogs";
import getScanOrUserLogContent from "./scanOrUserLogs";
import getTicketLogContent from "./ticketLogs";
import getUserActionLogContent from "./userActionLogs";

export const useLogContentCreator = (log) => {
  const ticketRelatedLogTypes = [
    ActivityLogType.TICKET_CREATED,
    ActivityLogType.TICKET_LINKED,
    ActivityLogType.TICKET_UNLINKED,
    ActivityLogType.TICKET_DELETED,
    ActivityLogType.TICKET_CREATED_FOR_ENTITY,
    ActivityLogType.TICKET_LINKED_FOR_ENTITY,
    ActivityLogType.TICKET_UNLINKED_FOR_ENTITY,
    ActivityLogType.TICKET_DELETED_FOR_ENTITY,
    ActivityLogType.TICKETS_CREATED_FOR_ENTITIES,
  ];

  const userActionRelatedLogTypes = [
    ActivityLogType.EXCLUDED_ENTITIES,
    ActivityLogType.INCLUDED_ENTITIES,
    ActivityLogType.CONTROL_SNOOZED,
    ActivityLogType.CONTROL_UNSNOOZED,
    ActivityLogType.SNOOZED_ENTITIES,
    ActivityLogType.UNSNOOZED_ENTITIES,
    ActivityLogType.SCAN,
    ActivityLogType.ASSIGNED,
    ActivityLogType.UNASSIGNED,
    ActivityLogType.SEVERITY_RAISED,
    ActivityLogType.SEVERITY_LOWERED,
    ActivityLogType.REMEDIATION_PRIORITY_RAISED,
    ActivityLogType.REMEDIATION_PRIORITY_LOWERED,
    ActivityLogType.DETECTION_RESOLVED,
    ActivityLogType.AUTO_REMEDIATION,
  ];

  const scanRelatedLogTypes = [
    ActivityLogType.NEW_GAP,
    ActivityLogType.NEW_COMPLIANT,
    ActivityLogType.TURNED_GAP,
    ActivityLogType.TURNED_COMPLIANT,
    ActivityLogType.APPLICABLE_GAP,
    ActivityLogType.APPLICABLE_COMPLIANT,
    ActivityLogType.NOT_APPLICABLE,
    ActivityLogType.IMPROVED,
    ActivityLogType.ESCALATED,
    ActivityLogType.CONTROL_SNOOZE_ENDED,
    ActivityLogType.ENTITY_SNOOZE_ENDED,
  ];

  const ScanOrUserRelatedLogTypes = [
    ActivityLogType.CONTROL_EXCLUDED,
    ActivityLogType.CONTROL_INCLUDED,
  ];

  if (ticketRelatedLogTypes.includes(log.log_type))
    return getTicketLogContent(log);

  if (userActionRelatedLogTypes.includes(log.log_type))
    return getUserActionLogContent(log);

  if (scanRelatedLogTypes.includes(log.log_type)) return getScanLogContent(log);

  if (ScanOrUserRelatedLogTypes.includes(log.log_type))
    return getScanOrUserLogContent(log);

  return null;
};
